import React, { createContext, useContext, useState } from 'react';

interface ScrollContextType {
  isAutoScrolling: boolean;
  setIsAutoScrolling: (value: boolean) => void;
}

const ScrollContext = createContext<ScrollContextType | undefined>(undefined);

export const ScrollProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAutoScrolling, setIsAutoScrolling] = useState(false);

  return (
    <ScrollContext.Provider value={{ isAutoScrolling, setIsAutoScrolling }}>
      {children}
    </ScrollContext.Provider>
  );
};

export const useScroll = (): ScrollContextType => {
  const context = useContext(ScrollContext);
  if (context === undefined) {
    throw new Error('useScroll must be used within a ScrollProvider');
  }
  return context;
};
